const AllInWorkouts = (() => {
    return {
        init() {
            $('.js-workout-read-more-btn').on('click', function() {
                $(this).toggleClass('hidden');
                $(this).prev().toggleClass('hidden');
                $(this).next().toggleClass('hidden');
            });
    
            $('.js-workout-read-less-btn').on('click', function() {
                $(this).toggleClass('hidden');
                $(this).prev().toggleClass('hidden');
                $(this).prev().prev().toggleClass('hidden');
            });
        }
    }
})();

export default (() => {
    $(document).ready(AllInWorkouts.init);
})();
